import { styled } from '@mui/styles';
import { colors } from '@mui/material';

export const StatusWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1, 3),
  borderRadius: theme.spacing(0.5),
  textWrap: 'nowrap'
}));

export const ActiveStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: theme.palette.success.light,
  color: theme.palette.success.dark
}));

export const CompletedStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: theme.palette.primary.light,
  color: theme.palette.primary.dark
}));

export const CancelledStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: theme.palette.grey[200],
  color: theme.palette.grey[600]
}));

export const PendingStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: theme.palette.warning.light,
  color: theme.palette.warning.dark
}));

export const PausedStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: colors.red[50],
  color: colors.red[700]
}));

export const RejectedStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: colors.red[50],
  color: colors.red[700]
}));

export const RejectedAnnualLimitStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: colors.red[50],
  color: colors.red[700]
}));
